<template>
  <div>
    <bar-manut single-entity="Inutilização" plural-entity="Inutilização" :crud="this.crud" @closeform="closeForm"
      @save="handleSave">
    </bar-manut>
    <div>
      <div class="default-container">
        <validation v-if="errmessages.length != 0" title="Erro ao enviar pedido de inutilização" :messages="errmessages">
        </validation>
        <div class="row">
          <form-field v-model="inut.codfil" type="select2" col="4" :metadata="metadata.inut.codfil" name="codfil"
            :v-errors="errors" v-validate="metadata.inut.codfil.validator"></form-field>

          <form-field v-model="inut.serie" type="number" col="2" :metadata="metadata.inut.serie" name="serie"
            :v-errors="errors" v-validate="metadata.inut.serie.validator"></form-field>

          <form-field v-model="inut.nfinicial" type="number" col="2" :metadata="metadata.inut.nfinicial" name="nfinicial"
            :v-errors="errors" v-validate="metadata.inut.nfinicial.validator"></form-field>

          <form-field v-model="inut.nffinal" type="number" col="2" :metadata="metadata.inut.nffinal" name="nffinal"
            :v-errors="errors" :v-validate="{ required: false }" :disabled="true"></form-field>

          <form-field v-model="inut.texto" type="text" col="6" :metadata="metadata.inut.texto" name="texto"
            :v-errors="errors" v-validate="metadata.inut.texto.validator"></form-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDS, apiORDSpost, urlODS } from '../shared/api-functions'

export default {
  props: {
    params: '',
    crud: '',
  },

  data() {
    return {
      crudText: '',
      inut: { ...this.$store.getters.getEntities.inut },
      iest: [],
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
    }
  },

  computed: {
    editing: function () {
      return this.crud == SysVars.crudU
    },
  },

  methods: {
    closeForm() {
      this.$emit('closeform')
    },

    handleSave() {
      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    handleDelete() {
      this.apiDelete()
    },

    async loadData() {
      //carrega o registro para alteracao ou visualizacao

      if (this.crud == SysVars.crudI) {
        this.inut.serie = '1'
        this.inut.esp = '55'
        return
      }

      await this.$store.dispatch('loadInut', { id: this.params.codinut })
      if (this.$store.getters.getInut) {
        this.inut = { ...this.$store.getters.getInut }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiDelete() {

    },

    async apiPost() {
      //efetua a gravacao
      if ((!this.inut.nffinal) || (this.inut.nffinal <= 0)) {
        this.inut.nffinal = this.inut.nfinicial
      }
      this.inut.texto = this.inut.texto.trim()

      let tipo = this.$certificadoCheck(this.inut.codfil)
      if (tipo == 'A3') {
        let paramsinut = '&nffinal=' + this.inut.nffinal
        paramsinut = paramsinut + '&nfinicial=' + this.inut.nfinicial
        paramsinut = paramsinut + '&esp=' + this.inut.esp
        paramsinut = paramsinut + '&serie=' + this.inut.serie
        paramsinut = paramsinut + '&texto=' + this.inut.texto
        this.$executaExtensaoChromeA3(null, 'inut', this.NFeResponseCallback, paramsinut)
        return
      } else {
        var sendData = {}
        sendData = this.inut

        let metodo = 'post'
        const data = await apiORDSpost(this.$store, 'invoice/inut2/', sendData, metodo)
        if (data.errmessages) {
          this.errmessages = data.errmessages
          this.$erpToastError('Erro ao enviar pedido de inutilização')
        } else {
          this.$erpToastSuccess('O Pedido de inutilização foi homologado.')
          this.errmessages = {}
          this.closeForm()
        }
      }
    },

    NFeResponseCallback(response) {
      //CALLBACK QUANDO A INUTILIZACAO É ENVIADA POR CERTIFICADO A3
      //console.log(response)
      this.$appLoading(false)
      this.errmessages = []
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        this.$erpToastSuccess('Inutilização homologada')
      }
      this.closeForm()
    },

  },

  components: {

  },

  beforeCreate() {

  },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.crudText = this.$crudText(this.crud)

    this.loadData()

    this.metadata.inut.nffinal.validator = null
    this.metadata.inut.nfinicial.validator = { required: true }
    this.metadata.inut.codfil.validator = { required: true }
  }

}

</script>

<style></style>



// WEBPACK FOOTER //
// src/forms/inut-form.vue